import SuccessWithdraw from './SuccessWithdraw/SuccessWithdraw'
import Message from './Message/Message'
import ErrorNotification from './ErrorNotification/ErrorNotification'
import BTCMultisignRequest from './BTCMultisignRequest/BTCMultisignRequest'
import Transaction from './Transaction'

export default {
  SuccessWithdraw,
  Message,
  ErrorNotification,
  BTCMultisignRequest,
  Transaction,
}
